<template>
  <div class="illust">
    <IllustListControll v-show="isShowIllustList"></IllustListControll>
    <IllustDetailControll v-show="isShowIllustDetail" v-bind:illustData="illustData" v-bind:previousID="previousID" v-bind:nextID="nextID"></IllustDetailControll>
  </div>
</template>

<script>
import IllustListControll from "./controlls/illust/IllustListControll";
import IllustDetailControll from "./controlls/illust/IllustDetailControll";

var _illustDatas = require('../assets/data/IllustDatas.json');

export default {
  name: 'Illust',
  props: ['id'],
  components: {
    IllustListControll, IllustDetailControll
  },
  computed:{
    isShowIllustList: function(){
      return true;
    },
    isShowIllustDetail: function(){
      return this.id != undefined;
    },
    illustData: function(){
      if(this.id != undefined){
        return _illustDatas.find(data => data.id == this.id);
      }
      else{
        return null;
      }
    },
    previousID: function(){
      if(this.id != undefined){
        var index = _illustDatas.findIndex(data => data.id == this.id);
        if(index == 0){
          return _illustDatas[_illustDatas.length - 1].id;
        }
        else{
          return _illustDatas[index - 1].id;
        }
      }
      else{
        return null;
      }
    },
    nextID: function(){
      if(this.id != undefined){
        var index = _illustDatas.findIndex(data => data.id == this.id);
        if(index + 1 == _illustDatas.length){
          return _illustDatas[0].id;
        }
        else{
          return _illustDatas[index + 1].id;
        }
      }
      else{
        return null;
      }
    }
  },
  beforeRouteEnter(to,from ,next){
    next(vm=>{
      if(vm.id != undefined && vm.illustData == undefined){
        vm.$router.push('/illust');
      }
    });
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.illust{
  background-image: url('../assets/cover_illust.png');
}
</style>
